// routes

// routes
import { PATH_MAIN } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => (
    <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);


const ICONS = {
    user: icon('ic_user'),
    ecommerce: icon('ic_ecommerce'),
    analytics: icon('ic_analytics'),
    dashboard: icon('ic_dashboard'),
    master: icon('ic_master'),
    settings: icon('ic_settings'),
    helpdesk: icon('ic_helpdesk'),
};


    const navConfig = [
        // GENERAL
        // ----------------------------------------------------------------------
        {
            items: [
                {
                    title: 'Entity',
                    path: PATH_MAIN.root,
                    icon: ICONS.user,
                    children: [
                        { title: 'Entity', path: PATH_MAIN.entitytype },
                        { title: 'Claim Document Details', path: PATH_MAIN.claimdocumentdetails },
                      
                    ],
                },
                // { title: 'Helpdesk', path: PATH_MAIN.five, icon: ICONS.settings },
                // { title: 'Settings', path: PATH_MAIN.six, icon: ICONS.helpdesk },

            ],
        }
    ];


export default navConfig;